module.exports = __webpack_public_path__ + "assets/img/latest_release copy.0bba1185.svg";